import Link from 'next/link';

import styles from 'global/styles/Contacts.module.scss';

import { Breadcrumbs, BreadcrumbType } from 'app/shared';
import StaticPagesMenu from '../components/StaticPages/Menu';

import VkIcon from '../templates/Footer/Credentials/VkIcon';
import SKIcon from '../templates/Footer/Credentials/SKIcon';
import { Icon } from '@nebo-team-dev/vobaza.ui.icon/dist';

const breadcrumbs: BreadcrumbType[] = [
  {
    title: 'Контакты',
    href: '/kontakty',
  },
];

export default function Contacts() {
  return (
    <div>
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <div className={`${styles.staticPage} container`}>
        <StaticPagesMenu />
        <div className={`${styles.staticPageContent} ${styles.contactsContent}`}>
          <div>
            <h1 className={styles.staticPageTitle}>Контакты</h1>
            <div className={styles.staticPageInfo}>
              <div className={styles.staticPageSubTitle}>
                <a href="tel:+74958990909" className={styles.link}>
                  +7 (495) 899-09-09
                </a>
              </div>
              <div className={`${styles.staticPageText} ${styles.gray}`}>Звонок бесплатный</div>
              <div className={styles.staticPageText}>
                Специалисты клиентской поддержки принимают звонки с&nbsp;9:00 до&nbsp;18:00, пн.— пт.
              </div>
            </div>

            <div className={styles.staticPageInfo}>
              <div className={`${styles.staticPageText} ${styles.bold}`}>Склад</div>
              <div className={styles.staticPageText}>
                <a
                  className={styles.link}
                  target="_blank"
                  href="https://yandex.ru/maps/10743/odincovo/house/vnukovskaya_ulitsa_9/Z04YdA9iT00OQFtvfXp0dn5nYQ==/?ll=37.282690%2C55.657245&z=16"
                  rel="noreferrer"
                >
                  143006&nbsp;Россия, Московская область, Одинцово,
                  <br /> Внуковская улица, 9
                </a>
              </div>
            </div>
            <div className={styles.staticPageInfo}>
              <div className={`${styles.staticPageText} ${styles.bold}`}>Главный офис</div>
              <div className={styles.staticPageText}>
                <a
                  className={styles.link}
                  target="_blank"
                  href="https://yandex.ru/maps/10743/odincovo/house/lugovaya_ulitsa_10/Z04YdQRgSEIDQFtvfXp5dXprYg==/?ll=37.330175%2C55.684686&z=16.72"
                  rel="noreferrer"
                >
                  Россия, Московская область, Одинцово,
                  <br /> Луговая улица, 10
                </a>
              </div>
            </div>
            <div className={styles.staticPageInfo}>
              <div className={`${styles.staticPageText} ${styles.bold}`}>Реквизиты</div>
              <div className={styles.staticPageText}>
                Наименование организации: ООО &laquo;Макрохим&raquo; ИНН/КПП 6167198895/616701001&nbsp;ОГРН 1206100021863
                Юридический адрес: 344111, Ростовская обл., г. Ростов-на-Дону, ул. 50-летия Октября, д. 33/1,
                офис&nbsp;1
              </div>
            </div>
            <div className={styles.staticPageInfo}>
              <div className={`${styles.staticPageText} ${styles.bold}`}>Почта для партнеров</div>
              <div>
                <a href="mailto:partners@vobaza.ru" className={`${styles.staticPageText} ${styles.link}`}>
                  partners@vobaza.ru
                </a>
              </div>
            </div>
            <div className={styles.staticPageInfo}>
              <div className={`${styles.staticPageText} ${styles.bold}`}>Подпишитесь в&nbsp;социальных сетях</div>
              <div className={styles.contactsSocial}>
                <a
                  href="https://vk.com/vobaza_official"
                  target="_blank"
                  className={styles.contactsSocialItem}
                  rel="noreferrer"
                >
                  <VkIcon />
                </a>
                <a
                  href="https://navigator.sk.ru/orn/1123813"
                  target="_blank"
                  className={styles.contactsSocialItemWide}
                  rel="noreferrer"
                >
                  <SKIcon />
                </a>
              </div>
            </div>
          </div>
          <div>
            <div className={styles.staticPageInfo}>
              <div className={`${styles.staticPageText} ${styles.bold}`}>Обратная связь</div>
              <div className={styles.staticPageText}>Если у&nbsp;вас возник вопрос&nbsp;&mdash; напишите нам</div>
              <Link href="/kontaktnaya-forma" className={styles.contactsButton}>
                Написать
                <Icon name="ArrowRight" />
              </Link>
            </div>
            <div className={styles.staticPageInfo}>
              <div className={`${styles.staticPageText} ${styles.bold}`}>Поставщикам</div>
              <div className={styles.staticPageText}>Узнайте подробные условия для сотрудничества</div>
              <Link href="/postavschikam-partneram" className={styles.contactsButton}>
                Узнать подробности
                <Icon name="ArrowRight" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
